var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoText2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256.7 69",
    style: {
      enableBackground: "new 0 0 256.7 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,12.9c-5.9-6-13.8-9.3-22.1-9.3s-16.2,3.3-22.1,9.3c-5.9,6-9.2,14-9.2,22.5s3.3,16.5,9.2,22.5 c5.9,6,13.8,9.3,22.1,9.3s16.2-3.3,22.1-9.3c2.1-2.1,3.9-4.5,5.3-7.1l0.2-0.4l-1.6-2.9L40,8.3C45.5,9.3,50.7,12,54.6,16 c5.1,5.2,7.9,12.1,7.9,19.4c0,2.1-0.2,4.3-0.7,6.3l-0.1,0.3l2.9,5.3l0.6-1.9c1-3.2,1.6-6.6,1.6-10C66.9,26.9,63.6,18.9,57.7,12.9z  M35.5,62.9c-7.2,0-14-2.9-19.1-8c-1.1-1.1-2.1-2.3-3-3.6l26.7,0l7.4,0l0,0h0l-0.6-1.3L30.6,21.4l5.4-9.7l21.9,39.2 c-0.9,1.4-2,2.7-3.2,4C49.5,60.1,42.8,62.9,35.5,62.9z M26.3,36.2l-2.8,4.9h12.8l2.9,5.1H18.2l9.4-17l-2.8-5L11.6,48.1 c-2-3.9-3-8.2-3-12.6c0-7.3,2.8-14.2,7.9-19.4c4.8-4.9,9.5-7.5,16.3-7.8l-7.5,13.5l8,14.1l0.2,0.4H26.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.4,16.9l8.4,22.4h-7.9l-0.9-3.1h-6.7l-0.9,3.1h-7.5l8.4-22.4H91.4z M87.6,25.2L86,30.7h3.3L87.6,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.8,39.3V16.9h10.5c2.5,0,4.6,0.7,6.1,2.1s2.4,3.3,2.4,5.6c0,2.9-1.2,5.1-3.6,6.7l4.5,8h-8.2l-3.4-6.7H123 v6.7H115.8z M125.3,22.9H123v4.2h2.3c0.8,0,1.3-0.2,1.8-0.6c0.4-0.4,0.6-0.9,0.6-1.6s-0.2-1.2-0.6-1.6 C126.7,23.1,126.1,22.9,125.3,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.4,16.9h7v12.9c0,3-0.9,5.3-2.8,7.1c-1.9,1.8-4.3,2.7-7.3,2.7c-3.1,0-5.5-0.9-7.3-2.6 c-1.8-1.7-2.7-4-2.7-7V16.9h7.3v12.9c0,1,0.3,1.8,0.8,2.3c0.5,0.6,1.2,0.9,2.1,0.9c0.9,0,1.6-0.3,2.2-0.9c0.5-0.6,0.8-1.4,0.8-2.3 V16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.4,39.3l-7.1-11.5v11.5h-6.9V16.9h7.4l6.7,10.9V16.9h7v22.4H204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.6,16.9h8.7c3.5,0,6.4,1.1,8.8,3.2c2.3,2.1,3.5,4.8,3.5,7.9s-1.2,5.9-3.6,8c-2.4,2.2-5.3,3.2-8.9,3.2h-8.5 V16.9z M236.8,23.2V33h1.6c1.5,0,2.7-0.5,3.6-1.4c0.9-0.9,1.4-2.1,1.4-3.5s-0.5-2.6-1.4-3.5c-0.9-0.9-2.1-1.4-3.6-1.4H236.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,54.3h-3.8l-0.8,1.8h-1.1l3.3-7.2h1l3.3,7.2h-1.1L82,54.3z M81.7,53.5L80.1,50l-1.5,3.5H81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.2,56.1l-1.5-2.2c-0.2,0-0.3,0-0.5,0h-1.8v2.2h-1v-7.2h2.8c0.9,0,1.7,0.2,2.2,0.7c0.5,0.4,0.8,1.1,0.8,1.8 c0,0.6-0.1,1-0.4,1.4c-0.3,0.4-0.7,0.7-1.2,0.9l1.7,2.4H94.2z M93.6,52.6c0.3-0.3,0.5-0.7,0.5-1.2s-0.2-0.9-0.5-1.2 s-0.8-0.4-1.5-0.4h-1.7V53h1.7C92.8,53,93.3,52.9,93.6,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.4,55.3c-0.5-0.5-0.8-1.3-0.8-2.4v-4.1h1v4c0,1.5,0.7,2.3,2,2.3c0.7,0,1.2-0.2,1.5-0.6 c0.3-0.4,0.5-1,0.5-1.7v-4h1V53c0,1-0.3,1.8-0.8,2.4c-0.5,0.5-1.3,0.8-2.2,0.8C99.7,56.2,98.9,55.9,98.4,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,48.9v7.2h-0.8l-4.3-5.4v5.4h-1v-7.2h0.8l4.3,5.4v-5.4H112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.9,48.9v7.2h-0.8l-4.3-5.4v5.4h-1v-7.2h0.8l4.3,5.4v-5.4H121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,48.9h1v7.2h-1V48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.1,48.9v7.2h-0.8l-4.3-5.4v5.4h-1v-7.2h0.8l4.3,5.4v-5.4H135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143,52.5h1v2.8c-0.4,0.3-0.8,0.5-1.2,0.7c-0.5,0.2-1,0.2-1.5,0.2c-0.7,0-1.4-0.2-2-0.5 c-0.6-0.3-1-0.8-1.4-1.3c-0.3-0.6-0.5-1.2-0.5-1.9s0.2-1.3,0.5-1.9c0.3-0.6,0.8-1,1.4-1.3s1.2-0.5,2-0.5c0.6,0,1.1,0.1,1.6,0.3 c0.5,0.2,0.9,0.5,1.2,0.8l-0.6,0.6c-0.6-0.6-1.3-0.8-2.1-0.8c-0.5,0-1,0.1-1.5,0.4s-0.8,0.6-1,1c-0.2,0.4-0.4,0.9-0.4,1.4 c0,0.5,0.1,1,0.4,1.4s0.6,0.8,1,1s0.9,0.4,1.5,0.4c0.6,0,1.2-0.2,1.7-0.5V52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,54.3h-3.8l-0.8,1.8h-1.1l3.3-7.2h1l3.3,7.2h-1.1L154.9,54.3z M154.6,53.5L153,50l-1.5,3.5H154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.7,48.9h3c0.8,0,1.4,0.2,2,0.5s1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9s-0.2,1.3-0.5,1.9 c-0.3,0.5-0.8,1-1.4,1.3s-1.3,0.5-2,0.5h-3V48.9z M161.6,55.2c0.6,0,1.1-0.1,1.5-0.3c0.4-0.2,0.8-0.5,1-0.9 c0.2-0.4,0.4-0.9,0.4-1.4s-0.1-1-0.4-1.4c-0.2-0.4-0.6-0.7-1-0.9c-0.4-0.2-1-0.3-1.5-0.3h-1.9v5.4H161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174,48.9l-3.1,7.2h-1l-3.2-7.2h1.1l2.6,5.9l2.6-5.9H174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.9,55.2v0.9h-5.2v-7.2h5.1v0.9h-4V52h3.6v0.9h-3.6v2.3H180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.2,56.1l-1.5-2.2c-0.2,0-0.3,0-0.5,0h-1.8v2.2h-1v-7.2h2.8c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.8 c0,0.6-0.1,1-0.4,1.4s-0.7,0.7-1.2,0.9l1.7,2.4H188.2z M187.7,52.6c0.3-0.3,0.5-0.7,0.5-1.2s-0.2-0.9-0.5-1.2 c-0.3-0.3-0.8-0.4-1.5-0.4h-1.7V53h1.7C186.8,53,187.3,52.9,187.7,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193,49.8h-2.5v-0.9h5.9v0.9H194v6.3h-1V49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.4,48.9h1v7.2h-1V48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.9,55.9c-0.5-0.2-0.9-0.4-1.2-0.7l0.4-0.8c0.3,0.2,0.6,0.4,1.1,0.6c0.4,0.2,0.9,0.2,1.3,0.2 c0.6,0,1-0.1,1.3-0.3c0.3-0.2,0.4-0.5,0.4-0.8c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.6-0.2-1-0.3 c-0.5-0.1-1-0.3-1.3-0.4c-0.3-0.1-0.6-0.3-0.9-0.6c-0.2-0.3-0.4-0.6-0.4-1.1c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.5-0.6,0.9-0.7 c0.4-0.2,0.9-0.3,1.5-0.3c0.4,0,0.8,0.1,1.3,0.2s0.8,0.3,1.1,0.5l-0.3,0.8c-0.3-0.2-0.6-0.3-1-0.4c-0.3-0.1-0.7-0.1-1-0.1 c-0.6,0-1,0.1-1.3,0.3c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.1,0.6,0.2,1,0.3 c0.5,0.1,1,0.3,1.3,0.4s0.6,0.3,0.8,0.6c0.2,0.3,0.4,0.6,0.4,1.1c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.6-0.9,0.7 c-0.4,0.2-0.9,0.3-1.5,0.3C204,56.2,203.5,56.1,202.9,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.8,55.2v0.9h-5.2v-7.2h5.1v0.9h-4V52h3.6v0.9h-3.6v2.3H214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,56.1l0-5.2l-2.6,4.4h-0.5l-2.6-4.3v5.2h-1v-7.2h0.8l3,5l3-5h0.8l0,7.2H224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.1,55.2v0.9h-5.2v-7.2h5.1v0.9h-4V52h3.6v0.9h-3.6v2.3H233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,48.9v7.2h-0.8l-4.3-5.4v5.4h-1v-7.2h0.8l4.3,5.4v-5.4H241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.2,49.8h-2.5v-0.9h5.9v0.9h-2.5v6.3h-1V49.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText2);
export default __webpack_public_path__ + "static/media/logo-text-2.c5d1ee1ac45fa6050be6c6a997a4d0b0.svg";
export { ForwardRef as ReactComponent };